<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-50 md-small-size-100">
      <lock-card>
        <img class="img" slot="imageProfile" :src="image" />
        <h4 slot="title" class="title">Tania Andrew</h4>
        <div class="md-field" slot="content">
          <label>Enter Password</label>
          <input class="md-input" v-model="password" type="password">
        </div>
        <button class="md-button md-success md-round" slot="footer"
          >Unlock</button
        >
      </lock-card>
    </div>
  </div>
</template>
<script>
import { LockCard } from "@/components";
export default {
  components: {
    LockCard,
  },
  data() {
    return {
      password: null,
      image: "/img/faces/avatar.jpg",
    };
  },
};
</script>
<style></style>
